export default __webpack_public_path__ + "static/media/cartIcon.99813b05.svg";